import React from "react";
import { Rect } from "react-konva";

import { Size } from "./types";

interface IProps {
  readonly size: Size;
}

export const Background = ({ size: { height, width } }: IProps) => (
  <Rect x={0} y={0} height={height} width={width} fill="lightgray" />
);
